<template>
    <app-content-admin>
        <template slot="header">{{ $t("create_banner") }}</template>

        <v-container>
            <v-form ref="form" lazy-validation v-model="valid" @submit.prevent="submit">
                <v-card class="px-4 mx-auto" max-width="900px">
                    <v-card-title>Banner Details</v-card-title>
                    
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">                            
                                <v-text-field
                                    v-model="form.title"
                                    label="Title"
                                    outlined
                                ></v-text-field>
                            </v-col>

                            <v-col cols="12">
                                <v-textarea
                                    v-model="form.description"
                                    outlined
                                    label="Description"
                                ></v-textarea>
                            </v-col>

                            <v-col cols="12">
                                <vue-dropzone
                                    id="image"
                                    ref="image"
                                    @vdropzone-success="uploadCallback"                                
                                    :options="dropzone_option"
                                    @vdropzone-removed-file="removedCallback">
                                </vue-dropzone>
                            </v-col>

                            <v-col cols="12">
                                <v-switch
                                    v-model="form.is_active"
                                    label="Enable Banner"
                                ></v-switch>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" type="submit">Submit</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-container>
    </app-content-admin>
</template>

<script>
import vForm from '@/mixins/vForm';
import Dropzone from '@/mixins/Dropzone'

export default {
    mixins: [vForm, Dropzone],
    
    data() {
        return {
            form: {
                is_active: 1,
                title: '',
                description: '',
                files: [],
            },
            dropzone_option: this.dropzoneOptions('image', api.path('banner.upload')),
        }
    },

    methods: {
        async submit() {
            let loader = this.$loading.show();

            await axios.post(api.path('banner.create'), this.form)
            .then(res => res.data)
                .then(res =>  {
                    this.$toastr.s(this.$t(res.message));
                    this.$refs.form.reset();
                    loader.hide();
            })
            .catch(error => {                
                this.$toastr.e(error.response.data.message);
                loader.hide();
            });

            loader.hide();
        },
    }
}
</script>
<style lang="">
    
</style>